<template>
  <main class="page">
    <section class="section page__header">
      <h1 class="title">Создать дочерний отдел</h1>
    </section>

    <div class="form__bg">
      <section class="section">
        <div class="form__inputs">
          <AppSelect v-if="newDepartment.parent.type === 0"
                     title="Тип дочернего отдела"
                     placeholder="Укажите тип отдела"
                     :value="newDepartment.type"
                     :options="departmentsTypeList"
                     @value-changed="setType"
          />
          <AppInput title="Название"
                    :value="newDepartment.name"
                    required
                    :valid="validation.name"
                    @value-changed="setName"
                    @got-focus="clearValidation('name')"
          />
          <AppSelect :title="headInputTitle()"
                     :placeholder="headInputPlaceholder()"
                     :value="newDepartment.head"
                     :options="leadersList"
                     :is-users="true"
                     @value-changed="setHead"
          />
        </div>
        <div class="form__inputs">
          <AppTextarea title="ЦКП"
                       :value="newDepartment.ckp"
                       input-height="200px"
                       @value-changed="setCkp"
          />
          <AppTextarea title="Обязанности"
                       :value="newDepartment.duties"
                       input-height="200px"
                       @value-changed="setDuties"
          />
          <AppInput title="Ссылка на должностные инструкции"
                      :value="newDepartment.instructions"
                      :valid="{}"
                      @value-changed="setInstructions"
          />
          <AppInput title="Ссылка на папку штатного сотрудника"
                    :value="newDepartment.folder"
                    :valid="{}"
                    @value-changed="setFolder"
          />
        </div>
        <div class="form__inputs form__inputs_col-1">
          <transition name="fade">
            <div class="page__row mb-40" v-show="newDepartment.type.id !== null && newDepartment.type.id !== 1 && newDepartment.type.id !== 2">
                <AppSelectMultiple title="Выбрать сотрудников"
                                   placeholder="Выберите сотрудников"
                                   :value="newDepartment.staff"
                                   :options="usersList"
                                   :is-users="true"
                                   @add-item="addNewStaffUser"
                                   @remove-item="removeNewStaffUser"
                />
            </div>
          </transition>
        </div>
        <!--<div class="page__row">
          <AppSelect title="Руководящий отдел"
                     placeholder="Укажите руководящий отдел"
                     :value="newDepartment.parent"
                     :options="departmentsList"
                     @value-changed="setParent"
          />
        </div>-->
      </section>

      <section class="section">
        <div class="page__buttons">
          <div class="page__item">
            <AppButton title="Cоздать"
                       type="main"
                       @click.native="createDepartment"
            />
          </div>
          <div class="page__item">
            <AppButton title="Отмена"
                       type="alt"
                       @click.native="departmentsTreePage"
            />
          </div>
        </div>
      </section>

      <transition name="fade">
        <AppModal v-if="modalActive.success"
                  title="Отдел успешно создан!"
                  confirm-button-type="main"
                  confirm-button-title="Ок"
                  @confirm="departmentsTreePage"
        />
        <AppModal v-if="modalActive.error"
                  title="Ошибка!"
                  text="Вернутся к созданию отдела"
                  confirm-button-type="main"
                  confirm-button-title="ОК"
                  @confirm="closeModal"
        />
      </transition>
    </div>
  </main>
</template>

<script>
import AppInput from '../../components/page/input/AppInput'
import AppButton from '../../components/page/button/AppButton'
import AppModal from '../../components/page/modal/AppModal'
import AppSelect from '../../components/page/input/AppSelect'
import AppTextarea from '@/components/page/input/AppTextarea'
import AppSelectMultiple from '@/components/page/input/AppSelectMultiple'

export default {
  components: {
    AppSelectMultiple,
    AppTextarea,
    AppSelect,
    AppModal,
    AppButton,
    AppInput
  },
  computed: {
    newDepartment () {
      return this.$store.getters.newDepartment
    },
    leadersList () {
      const userList = [...this.$store.getters['[dictionaries] usersList']]
      userList.unshift({
        id: null,
        name: 'Нет руководителя',
        avatar: 'no-avatar'
      })
      return userList
    },
    usersList () {
      return this.$store.getters['[dictionaries] usersList']
    },
    departmentsList () {
      return this.$store.getters['[dictionaries] usersDepartmentList']
    },
    modalActive () {
      return this.$store.getters.departmentCreatePageModals
    },
    validation () {
      return this.$store.getters.departmentCreateValidation
    },
    departmentsTypeList () {
      return [
        { id: 1, name: 'Исполнительный директор' },
        { id: 3, name: 'Отделение' },
        { id: 4, name: 'Отдел' }
      ]
    }
  },
  methods: {
    loadOptions () {
      this.$store.dispatch('[dictionaries] getUserList')
      this.$store.dispatch('[dictionaries] getDepartmentList')
    },
    createDepartment () {
      this.$store.dispatch('createDepartment')
    },
    departmentsTreePage () {
      this.$store.dispatch('departmentCreateClearFields')
      this.$router.push({ path: '/departments/tree' })
      this.closeModal()
    },
    closeModal () {
      this.$store.dispatch('closeDepartmentCreateModals')
    },
    clearValidation (input) {
      this.$store.dispatch('departmentCreateClearValidation', input)
    },

    setName (value) {
      this.$store.dispatch('setNewDepartmentName', value)
    },
    setHead (object) {
      this.$store.dispatch('setNewDepartmentHead', object)
    },
    setCkp (ckp) {
      this.$store.dispatch('setNewDepartmentCkp', ckp)
    },
    setDuties (duties) {
      this.$store.dispatch('setNewDepartmentDuties', duties)
    },
    setInstructions (instructions) {
      this.$store.dispatch('setNewDepartmentInstructions', instructions)
    },
    setFolder (folder) {
      this.$store.dispatch('setNewDepartmentFolder', folder)
    },
    addNewStaffUser (user) {
      this.$store.dispatch('addNewDepartmentStaffUser', { id: user.id, name: user.name })
    },
    removeNewStaffUser (user) {
      this.$store.dispatch('removeNewDepartmentStaffUser', { id: user.id, name: user.name })
    },
    // вручную тип устанавливается только в случае создания дочернего отдела у владельца
    // в иных случаях тип расчитывается автоматичсеки в сторе при создании отдела
    setType (type) {
      this.$store.dispatch('setNewDepartmentType', type)
    },
    setDefaultType () {
      switch (this.newDepartment.parent.type) {
        case 0:
          this.$store.dispatch('setNewDepartmentType', { id: 3, name: 'Отделение' })
          break
        case 1:
          this.$store.dispatch('setNewDepartmentType', { id: 2, name: 'Директор' })
          break
        case 2:
          this.$store.dispatch('setNewDepartmentType', { id: 3, name: 'Отделение' })
          break
        case 3:
          this.$store.dispatch('setNewDepartmentType', { id: 4, name: 'Отдел' })
          break
        case 4:
          this.$store.dispatch('setNewDepartmentType', { id: 5, name: 'Секция' })
          break
        case 5:
          this.$store.dispatch('setNewDepartmentType', { id: 6, name: 'Сектор' })
          break
        default:
          break
      }
    },
    // сейчас родительский отдел берется непосредственно из карточки отдела, откуда создается подотдел
    setParent (object) {
      this.$store.dispatch('setNewDepartmentParent', object)
    },
    headInputTitle () {
      let title = 'Руководитель'
      switch (this.newDepartment.type.id) {
        case 1:
          title = 'Сотрудник'
          break
        case 2:
          title = 'Сотрудник'
          break
      }
      return title
    },
    headInputPlaceholder () {
      let title = 'Укажите руководителя'
      switch (this.newDepartment.type.id) {
        case 1:
          title = 'Укажите сотрудника'
          break
        case 2:
          title = 'Укажите сотрудника'
          break
      }
      return title
    }
  },
  mounted () {
    this.loadOptions()
    this.setDefaultType()
    if (this.newDepartment.parent.id === null) {
      this.departmentsTreePage()
    }
  },
  updated () {
    this.headInputTitle()
    this.headInputPlaceholder()
  }
}

</script>

<style>

</style>
